

















































import Vue from 'vue';
import VueSkeletonLoader from 'skeleton-loader-vue';
import { skeletonDefaults } from './defaults';

export default Vue.extend({
  name: 'SearchBannerContentSkeleton',
  components: {
    VueSkeletonLoader,
  },
  data() {
    return {
      defaults: skeletonDefaults,
    };
  },
});
